export enum ColorPickerMode {
  NATIVE,
  LIMITED,
  FULL
}
